import axios from "axios";
import _ from "lodash";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_APP_UONO_API_ENDPOINT,
  headers,
});

export const useApiUonoClient = () => {
  return {
    setHasInsurance(tag: string) {
      return apiClient.get(`set-has-insurance`, { params: { tag } });
    },
    getTag(tagCode: string) {
      return apiClient.get(`get-tag-info`, { params: { tagCode } });
    },
  };
};
